<template>
	<div
		@mouseover="onMouseOver"
		ref="menu_item_container"
		@click="isTableOnly && setItem(item, itemKey)"
		:class="{ 'is-focused': isFocused, 'disable-hover': !isTableOnly }"
		class="data-input-item-container flex-space-between--center width-100"
	>
		<DataTableRepresentation
			:input="value"
			:noun="itemNoun"
			v-on="$listeners"
			:listKey="itemKey"
			:nodeUUID="item.key"
			:isTableFocused="isFocused"
			:searchString="searchString"
			class="input-item-container"
			:canChooseItems="!isTableOnly"
			ref="data_table_represantation"
			:useWithFormulas="useWithFormulas"
			:tableItemOutputLabels="tableOutputLabels"
			:didFocusFromBottomToTop="didFocusFromBottomToTop"
			@item-clicked="(...args) => tableColumnClicked(itemKey, ...args)"
			:class="{
				'is-focused': isFocused,
				'disable-hover': !isTableOnly,
			}"
		/>

		<DataItemInfoCard
			:item="item"
			:itemValue="value"
			:itemKey="itemKey"
			:stepIndex="stepIndex"
			:infoCardTop="infoCardTop"
			:searchString="searchString"
		/>
	</div>
</template>

<script>
import DataInputMenuItemBaseMixin from './DataInputMenuItemBaseMixin';
import DataInputMenuService from '@/components/DataInput/DataInputMenu/data-input-menu-service';
import DataTableRepresentation from '@/components/DataTableRepresentation/DataTableRepresentation';
import DataItemInfoCard from '@/components/DataInput/DataInputMenu/MenuLists/helpers/DataItemInfoCard';
import { FORMULAS_KEYS } from '@/components/common/RichTextBox/FormulaChip/formulas.const';

export default {
	name: 'DataInputTableItem',
	mixins: [DataInputMenuItemBaseMixin],
	props: {
		item: { type: Object },
		itemKey: { type: String },
		stepIndex: { type: Number },
		searchString: { type: String },
		isTableOnly: { type: Boolean },
		useWithFormulas: { type: Boolean },
		contentRectYAxis: { type: Number },
		focusedMenuItemKey: { type: String },
		didFocusFromBottomToTop: { type: Boolean },
		value: { type: [String, Number, Array, Object, Boolean] },
	},
	components: {
		DataItemInfoCard,
		DataTableRepresentation,
	},
	computed: {
		isFocused() {
			return this.focusedMenuItemKey === this.menuItemUniqueKey;
		},
		menuItemUniqueKey() {
			return DataInputMenuService.getMenuItemUniqueKey(this.item, this.itemKey);
		},
		dataTypeIconName() {
			return 'temp-data-type';
		},
		itemNoun() {
			return this.item?.nodeInfo?.noun;
		},
		tableOutputLabels() {
			return this.item?.outputLabels?.[this.itemKey] || {};
		},
	},
	methods: {
		getInfoCardTop() {
			const itemTop = this.$refs.menu_item_container?.getBoundingClientRect().y;
			if (this.contentRectYAxis > itemTop) {
				return this.contentRectYAxis;
			}
			return itemTop;
		},
		onMouseOver() {
			this.setInfoCardPosition();
			this.focusedMenuItemKey && this.$emit('focus-on-item', null); // clear focused menu item if hovering on another
		},
		setInfoCardPosition() {
			this.infoCardTop = this.getInfoCardTop();
		},
		setItem(...args) {
			this.$emit('set-data-input-menu-item', ...args);
		},
		tableColumnClicked(listKey, { value, index, ignoreValue }) {
			if (!this.useWithFormulas) {
				return this.$emit('item-clicked', { value, index });
			}
			/**
			 * we used to get the index from the clicked item, but in order to support extracting ONLY THE FIRST (!!) item of the table,
			 * we ignore the index received and set it to 0 (first index)
			 *
			 * setting the formula
			 */
			const elementInListParams = !ignoreValue ? [value] : [];
			this.setItem(this.item, listKey, FORMULAS_KEYS.VALUE_IN_FIRST_ELEMENT, elementInListParams);
		},
		focusOnNextMenuItem() {
			// Called from Parent
			this.passEventToChild('focusOnNextMenuItem');
		},
		focusOnPreviousMenuItem() {
			// Called from Parent
			this.passEventToChild('focusOnPreviousMenuItem');
		},
		selectFocusedItem() {
			// Called from Parent
			this.passEventToChild('selectFocusedItem');
		},
		passEventToChild(funcName) {
			if (this.isFocused) {
				this.$refs.data_table_represantation[funcName]();
			}
		},
	},
	watch: {
		isFocused: {
			handler(newV) {
				if (newV) {
					const menuItemRect = this.$refs.menu_item_container?.getBoundingClientRect() || {};
					this.isTableOnly && this.$emit('scroll-to-element', menuItemRect);
					this.setInfoCardPosition();
				}
			},
		},
	},
	data() {
		return {
			infoCardTop: 0,
		};
	},
};
</script>

<style scoped lang="scss">
.data-input-item-container {
	&:hover,
	&.is-focused {
		&:not(.disable-hover) {
			.data-input-item-info-card-container {
				display: flex;
				padding: 6px;
				position: fixed;
				margin-left: -262px;
			}
		}
	}

	.input-item-container {
		padding: 0px 6px;
		background: var(--bg-color);
		font-size: 12px;
		&:not(.disable-hover) {
			cursor: pointer;
		}

		&:hover,
		&.is-focused {
			&:not(.disable-hover) {
				background: var(--ask-for-ingreation-hover-background);
			}
		}
	}
}
</style>
